export function $lockScroll(): void {
  const scrollBarOffset = getScrollBarWidth()
  const styles = `
    position: relative;
    height: 100%;
    overflow: hidden;
    left: -${scrollBarOffset / 2}px;
  `

  setBodyStyles(styles)
}

export function $unlockScroll(): void {
  setBodyStyles('')
}

function setBodyStyles(styles: string): void {
  document.body.style.cssText = styles
}
